import CardUpNext from '@ifit/mp-card-up-next';
import { useContext } from 'react';
import { IUpNextItemAndDetails } from './index';
import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';
import { globalizeCompletedDate } from '../../util/date-utils';
import { getResizedImageUrl } from '../../util/get-resized-image-url';
import { IUpNextItemType } from '@ifit/gateway-wolf-dashboard-service';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import { DefaultImages } from '@ifit/img/out/defaults';

interface IUpNextItemPassedProps {
  item: IUpNextItemAndDetails;
}

export type IUpNextItemProps = IUpNextItemPassedProps;

export default function UpNextItem(props: IUpNextItemProps): JSX.Element {
  const { upNextItem, userWorkoutDetail, userSeriesDetail } = props.item;
  const { theme } = useContext(ThemeContext);
  const clickHandler = getUserNavigationHandler(upNextItem.navigationUrl, ROWTITLES.UP_NEXT_ITEM);

  const sizedImageUrl = getResizedImageUrl(upNextItem.imageUrl, DefaultImages.LargeCard, { width: 602, height: 608 });

  let completedDate: string;
  if (upNextItem.type === IUpNextItemType.ContinueSeriesWorkout) {
    completedDate = props.item.userSeriesDetail?.completedDate;
  } else if (upNextItem.type === IUpNextItemType.ContinueChallengeWorkout) {
    completedDate = upNextItem.completedDate;
  } else {
    completedDate = props.item.userWorkoutDetail?.completedDate;
  }

  return (
    <CardUpNext
      imageUrl={sizedImageUrl}
      isLive={upNextItem.isLive}
      tagPrimary={upNextItem.tagPrimary}
      title={upNextItem.title}
      averageRating={upNextItem.averageRating}
      callToAction={upNextItem.callToAction}
      callToActionShort={upNextItem.callToActionShort}
      colorScheme={theme === 'VAULT' ? 'vault' : null}
      leadLine={upNextItem.leadLine}
      progress={upNextItem?.progress ? upNextItem.progress : null}
      subtitle={upNextItem.subtitle}
      onClick={clickHandler}
      completed={globalizeCompletedDate(completedDate)}
      locked={userWorkoutDetail?.locked || userSeriesDetail?.locked || upNextItem?.locked === true}
      recommended={upNextItem.type === IUpNextItemType.RecommendedWorkout}
    />
  );
}
